export default function buildRidePromotionsMap(promotions) {
  const map = new Map();

  promotions.forEach((promo) => {
    const start = promo?.start_station_code || '*';
    const end = promo?.end_station_code || '*';
    const key = `${start}-${end}-${promo.type}-${promo.locale}`;
    map.set(key, promo);
  });

  return map;
}
